export default function AnalyticsStrategy() {
  const foundations = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'UTM-метки',
      desc: 'Без корректной разметки каждого объявления аналитика превращается в кашу.',
    },
    {
      icon: 'ri-fingerprint-line',
      title: 'Идентификатор ClientID',
      desc: 'Уникальный номер пользователя, чтобы «склеить» все действия одного и того же человека в единую историю.',
    },
    {
      icon: 'ri-phone-find-line',
      title: 'Коллтрекинг и формы',
      desc: 'Обязательная фиксация всех точек касания. Если клиент позвонил, а система этого не увидела — данные искажены.',
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'Обратный поток данных',
      desc: 'Чтобы аналитика «видела» деньги из CRM, а не просто количество заявок.',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-[#1A2B4C]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Main block */}
        <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 items-start mb-14 sm:mb-20">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#C5A880]/20 border border-[#C5A880]/30 rounded-full px-5 py-2 mb-7">
              <i className="ri-settings-4-line text-[#C5A880] text-lg"></i>
              <span className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] uppercase tracking-wider">Индивидуальный подход</span>
            </div>
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-6 font-['Playfair_Display'] leading-tight">
              Сквозная аналитика — это не шаблон, а стратегия.
            </h2>
            <p className="text-base sm:text-lg text-white/80 leading-relaxed font-['Montserrat'] mb-5 text-justify">
              Сквозная аналитика — это не покупка дорогого софта (программного&nbsp; обеспечения), а настройка ваших бизнес-процессов. Для одного бизнеса важен учет звонков, для другого — интеграция офлайн-касс или учет повторных продаж (LTV).
            </p>
            <p className="text-base sm:text-lg text-white/80 leading-relaxed font-['Montserrat'] text-justify">
              Мы создаем систему, которая отражает реальный путь вашего клиента, используя оптимальный набор инструментов без переплат за ненужный функционал.
            </p>
            <a
              href="#analytics-lead-form"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 mt-8 bg-[#C5A880] hover:bg-[#B39770] text-white px-7 sm:px-8 py-4 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 hover:scale-105 cursor-pointer font-['Montserrat'] whitespace-nowrap"
            >
              Получить план оцифровки бизнеса
              <i className="ri-arrow-right-line text-lg flex-shrink-0"></i>
            </a>
          </div>

          {/* Comparison boxes */}
          <div className="space-y-4">
            {[
              { title: 'Для B2C с офлайн-продажами', items: ['Коллтрекинг + интеграция кассы', 'Учет LTV и повторных покупок', 'Связка с CRM и 1С'] },
              { title: 'Для B2B и услуг', items: ['Длинные сделки и воронка продаж', 'Трекинг каждого касания менеджера', 'ROI по каждому лид-источнику'] },
              { title: 'Для интернет-магазинов', items: ['Enhanced Ecommerce GA4', 'Корзина, чекаут, возврат', 'Когортный анализ покупателей'] },
            ].map((box, i) => (
              <div key={i} className="bg-white/10 border border-white/15 rounded-2xl p-5 sm:p-6">
                <h4 className="text-base font-bold text-[#C5A880] mb-3 font-['Montserrat']">{box.title}</h4>
                <ul className="space-y-1.5">
                  {box.items.map((item, j) => (
                    <li key={j} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-line text-[#C5A880] text-base flex-shrink-0"></i>
                      <span className="text-sm text-white/80 font-['Montserrat'] text-justify">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Technical foundation */}
        <div>
          <h3 className="text-xl sm:text-3xl font-bold text-white text-center mb-10 font-['Playfair_Display']">
            Технический фундамент Сквозной Аналитики
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {foundations.map((f, i) => (
              <div key={i} className="bg-white/10 border border-white/15 rounded-2xl p-6 hover:bg-white/15 transition-colors duration-300">
                <div className="w-12 h-12 bg-[#C5A880] rounded-xl flex items-center justify-center mb-4">
                  <i className={`${f.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-base font-bold text-white mb-2 font-['Montserrat']">{f.title}</h4>
                <p className="text-sm text-white/70 leading-relaxed font-['Montserrat'] text-justify">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
